import Lottie from 'lottie-web';

export default class OurTechnology {
  init() {
    this._initLottieAnimation();
  }

  _initLottieAnimation() {
    let containerElem = document.body.querySelector('.illiustration-animation-wrapper-circle');
    let containerElemCharter = document.body.querySelector('.illiustration-animation-wrapper-charter');
    let containerElemGears = document.body.querySelector('.illiustration-animation-wrapper-gears');
    let containerElemCube = document.body.querySelector('.illiustration-animation-wrapper-cube');

    Lottie.loadAnimation({
      container: containerElem, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: './images/arweave-animation-circle.data.json' // the path to the animation json
    });
    Lottie.loadAnimation({
      container: containerElemCharter, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: './images/arweave-animation-charter.data.json' // the path to the animation json
    });
    Lottie.loadAnimation({
      container: containerElemGears, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: './images/arweave-animation-gears.data.json' // the path to the animation json
    });
    Lottie.loadAnimation({
      container: containerElemCube, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: './images/arweave-animation-cube.data.json' // the path to the animation json
    });

  }
}
